import { FormEvent, useState } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";

import { ApiError, login } from "../api";
import type { User } from "../types";


interface Props {
  onAuthenticated: (token: string, user: User) => void;
}

export default function LoginScreen({ onAuthenticated }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const result = await login(username, password);
      onAuthenticated(result.token, result.user);
    } catch (caught) {
      setError(
        caught instanceof ApiError
          ? caught.message
          : "Non è stato possibile accedere. Riprova.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-visual" aria-hidden="true">
        <div className="login-orbit login-orbit-one" />
        <div className="login-orbit login-orbit-two" />
        <div className="login-visual-content">
          <img
            className="brand-logo login-brand-logo"
            src="/gdp-logo.png"
            alt=""
          />
          <p className="eyebrow">GDP Analytics</p>
          <h1>Le conversazioni,<br />finalmente in un solo posto.</h1>
          <p>
            Gestisci il passaggio tra assistente e operatore senza perdere
            messaggi, contesto o allegati.
          </p>
        </div>
      </section>

      <section className="login-panel">
        <form className="login-card" onSubmit={handleSubmit}>
          <div className="login-mobile-brand">
            <img
              className="brand-logo login-mobile-logo"
              src="/gdp-logo.png"
              alt=""
            />
            <span>GDP WhatsApp</span>
          </div>
          <div>
            <p className="eyebrow">Area riservata</p>
            <h2>Bentornato</h2>
            <p className="login-subtitle">
              Accedi con il tuo account operatore.
            </p>
          </div>

          <label className="field">
            <span>Nome utente</span>
            <input
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="nome.cognome"
              required
            />
          </label>

          <label className="field">
            <span>Password</span>
            <div className="input-with-icon">
              <LockKeyhole size={17} aria-hidden="true" />
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="••••••••••••"
                required
              />
            </div>
          </label>

          {error && <div className="form-error" role="alert">{error}</div>}

          <button className="primary-button login-button" disabled={submitting}>
            <span>{submitting ? "Accesso in corso…" : "Accedi"}</span>
            {!submitting && <ArrowRight size={18} />}
          </button>
        </form>
      </section>
    </main>
  );
}
